import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';
import { InstallmentPlan } from '../../../../../model/installment-plan';
import { TextService } from '../../../../../shared/services/text.service';
import { SdkInitText } from '../../../../../model/user/sdk-init-text';

@Component({
  selector: 'pa-installment-options-mobile',
  templateUrl: './installment-options-mobile.component.html',
  styleUrls: ['./installment-options-mobile.component.scss']
})
export class InstallmentOptionsMobileComponent implements OnInit,OnChanges {
  @Input() installmentOptions: Array<InstallmentPlan>;
  @Input() sdkInitTexts: Array<SdkInitText>;
  @Output() installmentChange = new EventEmitter();
  installmentOption: InstallmentPlan;
  textService: TextService;

  panel = {
    active: false,
    name: 'Taksit Seçenekleri',
    disabled: false,
    icon: 'down'
  };

  constructor(textService: TextService) {
    this.textService = textService;
  }

  ngOnInit(): void {
    this.markSingleChoiceInstallmentOption();
  }

  ngOnChanges() {
    this.markSingleChoiceInstallmentOption();
  }

  onChange(event: MatRadioChange) {
    this.installmentChange.emit(this.installmentOption);
  }

  markSingleChoiceInstallmentOption() {
    this.installmentOptions.forEach(x => {
      if (x.count == 1) {
        this.installmentOption = x;
        this.installmentChange.emit(this.installmentOption);
      }
    });
  }
}
